import { StateType } from "@/types";
import { Module } from "vuex";

const initialShopcarNums = (() => {
  if (typeof window === 'undefined') return 0
  try {
    const raw = localStorage.getItem('shopcarNums') || '0'
    const parsed = Number(raw)
    return Number.isFinite(parsed) ? parsed : 0
  } catch (err) {
    return 0
  }
})()

const state = {
  shopcarNums: initialShopcarNums,
  shipProducts: [],
  buyNowData: null,
  orderCountsNum: {},
};
type ProductsStateType = typeof state;

const products: Module<ProductsStateType, StateType> = {
  namespaced: true,
  ...state,
};

export { ProductsStateType, state };
export default products;
